/**
 * ewc-cart — gaveta de carrinho independente de tema.
 *
 * Painel próprio, montado a partir do /cart.js. Não depende de seção do tema, de
 * re-render por "sections", nem da marcação da gaveta nativa (que fica escondida).
 * O único contato com o tema é o ADAPTADOR: o que abre a gaveta (link/ícone do
 * carrinho e formulário de compra) e onde fica o contador de itens. Tudo com
 * detecção automática e escape manual pela config.
 *
 * Falha aberto: qualquer erro deixa o tema funcionando como antes.
 */
(function () {
  'use strict';
  if (window.EwcCart) return;

  var PADRAO = {
    textos: {
      titulo: 'Your Cart', vazio: 'Your cart is empty', anuncio: '', recompensa_antes: 'Only {{restante}} away from a {{brinde}}',
      recompensa_depois: 'You got a {{brinde}}!', economia: 'You Save', economia_item: '', subtotal: 'Subtotal', checkout: 'CHECKOUT →',
      remover: 'Remove', upsell_titulo: 'Add More & Save More', upsell_adicionar: 'Add', garantia: '', so_upsell: 'Add a product to check out', gratis: 'FREE',
      continuar: '', imposto: ''
    },
    cores: { destaque: '#111111', fundo: '#ffffff', texto: '#111111', recompensa: '#ecb4cc', recompensa_trilho: '',
             anuncio_fundo: '', anuncio_texto: '', anuncio_borda: '', economia: '', rodape_fundo: '' },
    logo: '', logo_altura: 0, largura: 440, raio: 10, timer_segundos: 0,
    brinde: null, upsells: [], selos: [],
    modulos: { anuncio: true, recompensas: true, upsells: true, selos: true, gate_so_upsell: true, economia: true },
    adaptador: { gatilhos: '', contadores: '', gaveta_nativa: '', ignorar_formularios: '', abrir_ao_adicionar: true }
  };

  var SEL = {
    gatilhos: 'a[href$="/cart"],a[href*="/cart?"],a[href$="/cart/"],[data-cart-drawer-toggle],[data-cart-toggle],cart-drawer-toggle,' +
              '#cart-icon-bubble,.header__icon--cart,.cart-icon,.js-drawer-open-cart,[aria-controls="cart-drawer"],[aria-controls="CartDrawer"],[data-action="open-cart"],' +
              // Horizon: a sacola e um <button> com <cart-icon> dentro, sem href e sem data-*
              'cart-icon,.header-actions__cart-icon,.header-actions__action[aria-label*="art"]',
    contadores: '.cart-count-bubble span[aria-hidden],.cart-count-bubble span:not(.visually-hidden),[data-cart-count],.cart-count,.cart-item-count,' +
                '.header__cart-count,.cart-link__bubble-num,.site-header__cart-count span,[data-header-cart-count]',
    gaveta_nativa: 'cart-drawer,#CartDrawer,.cart-drawer,#cart-drawer,#shopify-section-cart-drawer,.drawer--cart,[data-cart-drawer],.mini-cart,#mini-cart,' +
                   '.cart-popup,cart-notification,#cart-notification,.cart-notification,.upcart-cart'
  };

  var cfg, raiz, refs = {}, carrinho = null, aberto = false, ocupado = false, relogio = null, cacheProduto = {}, produtoPronto = {};

  /* ------------------------------------------------------------ util */
  function juntar(base, extra) {
    var s = {};
    Object.keys(base).forEach(function (k) { s[k] = base[k]; });
    Object.keys(extra || {}).forEach(function (k) {
      if (extra[k] && typeof extra[k] === 'object' && !Array.isArray(extra[k]) && base[k] && typeof base[k] === 'object')
        s[k] = juntar(base[k], extra[k]);
      else if (extra[k] !== undefined && extra[k] !== null) s[k] = extra[k];
    });
    return s;
  }
  function lerConfig() {
    var no = document.querySelector('[data-ewc-cart-config]');
    var bruto = {};
    try { bruto = JSON.parse(no ? no.textContent : '{}'); } catch (e) { bruto = {}; }
    var c = juntar(PADRAO, bruto.config || {});
    c.moneyFormat = bruto.moneyFormat || '${{amount}}';
    if (!c.logo && bruto.logo) c.logo = bruto.logo;
    c.rotas = bruto.rotas || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || c.rotas.raiz || '/';
    c.raiz = root.replace(/\/?$/, '/');
    return c;
  }
  function dinheiro(centavos) {
    var f = cfg.moneyFormat, v = (centavos / 100).toFixed(2), p = v.split('.');
    var inteiro = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/g, inteiro + '.' + p[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, inteiro)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.') + ',' + p[1])
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.'))
            .replace(/<[^>]*>/g, '');
  }
  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }
  function tpl(texto, vars) {
    return String(texto || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function ehBrinde(item) { return !!(item.properties && item.properties._ewc_gift) || (cfg.brinde && String(item.variant_id) === String(cfg.brinde.variante_id)); }
  function ehUpsell(item) { return !!(item.properties && (item.properties._ewc_upsell || item.properties.__upsell)); }
  function principais(c) { return c.items.filter(function (i) { return !ehBrinde(i) && !ehUpsell(i); }); }

  /* ------------------------------------------------------------ api */
  function pedir(rota, opts) {
    return fetch(cfg.raiz + rota, opts).then(function (r) {
      if (!r.ok) throw new Error(rota + ' ' + r.status);
      return r.json();
    });
  }
  var api = {
    carrinho: function () { return pedir('cart.js', { headers: { Accept: 'application/json' } }); },
    add: function (itens) {
      return pedir('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) });
    },
    change: function (chave, qtd) {
      return pedir('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: chave, quantity: qtd }) });
    },
    produto: function (handle) {
      if (cacheProduto[handle]) return cacheProduto[handle];
      cacheProduto[handle] = pedir('products/' + handle + '.js')
        .then(function (p) { if (p) produtoPronto[handle] = p; return p; })
        .catch(function () { delete cacheProduto[handle]; return null; });
      return cacheProduto[handle];
    }
  };

  /* ------------------------------------------------------------ montagem */
  function montar() {
    raiz.innerHTML = '';
    raiz.style.setProperty('--ewc-acento', cfg.cores.destaque);
    raiz.style.setProperty('--ewc-fundo', cfg.cores.fundo);
    raiz.style.setProperty('--ewc-texto', cfg.cores.texto);
    raiz.style.setProperty('--ewc-recompensa', cfg.cores.recompensa);
    if (cfg.cores.recompensa_trilho) raiz.style.setProperty('--ewc-recompensa-trilho', cfg.cores.recompensa_trilho);
    if (cfg.cores.anuncio_fundo) raiz.style.setProperty('--ewc-anuncio-fundo', cfg.cores.anuncio_fundo);
    if (cfg.cores.anuncio_texto) raiz.style.setProperty('--ewc-anuncio-cor', cfg.cores.anuncio_texto);
    if (cfg.cores.anuncio_borda) raiz.style.setProperty('--ewc-anuncio-borda', cfg.cores.anuncio_borda);
    if (cfg.cores.economia) raiz.style.setProperty('--ewc-economia', cfg.cores.economia);
    if (cfg.cores.rodape_fundo) raiz.style.setProperty('--ewc-rodape-fundo', cfg.cores.rodape_fundo);
    if (cfg.cores.cartao_fundo) raiz.style.setProperty('--ewc-cartao-fundo', cfg.cores.cartao_fundo);
    raiz.style.setProperty('--ewc-largura', cfg.largura + 'px');
    raiz.style.setProperty('--ewc-raio', cfg.raio + 'px');
    if (cfg.fonte) raiz.style.setProperty('--ewc-fonte', cfg.fonte);

    var fundo = el('div', 'ewc-cart__fundo'); fundo.addEventListener('click', fechar);
    var painel = el('aside', 'ewc-cart__painel'); painel.setAttribute('role', 'dialog'); painel.setAttribute('aria-modal', 'true');

    var topo = el('div', 'ewc-cart__topo');
    if (cfg.logo) {
      refs.titulo = el('div', 'ewc-cart__titulo');
      var marca = el('img', 'ewc-cart__logo'); marca.src = cfg.logo; marca.alt = '';
      if (cfg.logo_altura) marca.style.height = cfg.logo_altura + 'px';
      refs.titulo.appendChild(marca);
    } else refs.titulo = el('h2', 'ewc-cart__titulo', cfg.textos.titulo);
    var fecharBtn = el('button', 'ewc-cart__fechar'); fecharBtn.type = 'button'; fecharBtn.setAttribute('aria-label', 'Close');
    fecharBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg>';
    fecharBtn.addEventListener('click', fechar);
    topo.appendChild(refs.titulo); topo.appendChild(fecharBtn);

    refs.anuncio = el('div', 'ewc-cart__anuncio'); refs.anuncio.hidden = true;
    refs.anuncioTexto = el('span', null, cfg.textos.anuncio); refs.timer = el('span', 'ewc-cart__timer');
    refs.anuncio.appendChild(refs.anuncioTexto); refs.anuncio.appendChild(refs.timer);

    refs.recompensas = el('div', 'ewc-cart__recompensas'); refs.recompensas.hidden = true;
    refs.recompensaMsg = el('p', 'ewc-cart__recompensas-msg');
    var trilho = el('div', 'ewc-cart__trilho'); refs.preench = el('div', 'ewc-cart__preenchimento');
    var marco = el('div', 'ewc-cart__marco'); refs.marcoIcone = el('div', 'ewc-cart__marco-icone');
    refs.marcoIcone.innerHTML = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M3 8h14v9H3zM2 5h16v3H2zM10 5v12M7 5c-1.5 0-2.5-1-2.5-2S5.5 1 7 1s3 2 3 4M13 5c1.5 0 2.5-1 2.5-2S14.5 1 13 1s-3 2-3 4"/></svg>';
    refs.marcoRotulo = el('div', 'ewc-cart__marco-rotulo', cfg.brinde ? cfg.brinde.rotulo : '');
    marco.appendChild(refs.marcoIcone); marco.appendChild(refs.marcoRotulo);
    trilho.appendChild(refs.preench); trilho.appendChild(marco);
    refs.recompensas.appendChild(refs.recompensaMsg); refs.recompensas.appendChild(trilho);

    refs.corpo = el('div', 'ewc-cart__corpo');
    refs.itens = el('div', 'ewc-cart__itens');
    refs.upsells = el('div', 'ewc-cart__upsells'); refs.upsells.hidden = true;
    refs.corpo.appendChild(refs.itens); refs.corpo.appendChild(refs.upsells);

    var rodape = el('div', 'ewc-cart__rodape');
    refs.economia = el('div', 'ewc-cart__economia'); refs.economia.hidden = true;
    refs.economia.appendChild(el('span', null, cfg.textos.economia)); refs.economiaValor = el('span'); refs.economia.appendChild(refs.economiaValor);
    var subtotal = el('div', 'ewc-cart__subtotal'); subtotal.appendChild(el('span', null, cfg.textos.subtotal)); refs.subtotal = el('span'); subtotal.appendChild(refs.subtotal);
    refs.aviso = el('div', 'ewc-cart__aviso', cfg.textos.so_upsell); refs.aviso.hidden = true;
    refs.checkout = el('a', 'ewc-cart__checkout', cfg.textos.checkout); refs.checkout.href = cfg.raiz + 'checkout';
    refs.checkout.addEventListener('click', function (ev) { if (refs.checkout.classList.contains('is-disabled')) ev.preventDefault(); });
    rodape.appendChild(refs.economia); rodape.appendChild(subtotal); rodape.appendChild(refs.aviso); rodape.appendChild(refs.checkout);
    if (cfg.textos.imposto) rodape.appendChild(el('p', 'ewc-cart__imposto', cfg.textos.imposto));
    if (cfg.textos.continuar) {
      var seguir = el('button', 'ewc-cart__continuar', cfg.textos.continuar); seguir.type = 'button';
      seguir.addEventListener('click', fechar); rodape.appendChild(seguir);
    }
    if (cfg.textos.garantia) rodape.appendChild(el('p', 'ewc-cart__garantia', cfg.textos.garantia));
    if (cfg.modulos.selos && cfg.selos && cfg.selos.length) {
      var selos = el('div', 'ewc-cart__selos');
      // a propria pagina ja desenha a tira de bandeiras no rodape: clonar dali sai igual
      var fonte = cfg.adaptador.selos_seletor ? document.querySelector(cfg.adaptador.selos_seletor) : null;
      if (fonte) {
        var copia = fonte.cloneNode(true); copia.removeAttribute('id');
        selos.classList.add('ewc-cart__selos--copia'); selos.appendChild(copia);
      } else cfg.selos.forEach(function (nome) {
        var svg = document.querySelector('template[data-ewc-selo="' + nome + '"]');
        if (svg) selos.appendChild(svg.content.cloneNode(true));
        else { var chip = el('span', 'ewc-cart__chip', String(nome).replace(/_/g, ' ').toUpperCase()); chip.style.background = '#eee'; chip.style.color = '#333'; selos.appendChild(chip); }
      });
      rodape.appendChild(selos);
    }

    painel.appendChild(topo); painel.appendChild(refs.anuncio); painel.appendChild(refs.recompensas);
    painel.appendChild(refs.corpo); painel.appendChild(rodape);
    raiz.appendChild(fundo); raiz.appendChild(painel);

    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-ewc-acao]');
      if (!b) return;
      var acao = b.getAttribute('data-ewc-acao'), chave = b.getAttribute('data-ewc-chave'), qtd = parseInt(b.getAttribute('data-ewc-qtd') || '0', 10);
      if (acao === 'mais') mudar(chave, qtd + 1);
      else if (acao === 'menos') mudar(chave, Math.max(0, qtd - 1));
      else if (acao === 'remover') mudar(chave, 0);
      else if (acao === 'upsell') adicionarUpsell(b);
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && aberto) fechar(); });
  }

  /* ------------------------------------------------------------ render */
  function render(c) {
    carrinho = c;
    var vazio = !c.items.length;
    refs.itens.innerHTML = '';
    if (vazio) refs.itens.appendChild(el('div', 'ewc-cart__vazio', cfg.textos.vazio));
    c.items.forEach(function (item) { refs.itens.appendChild(linha(item)); });

    if (!cfg.logo) refs.titulo.textContent = /\{\{\s*cart_quantity\s*\}\}/.test(cfg.textos.titulo)
      ? tpl(cfg.textos.titulo, { cart_quantity: c.item_count })
      : cfg.textos.titulo + (c.item_count ? ' • ' + c.item_count : '');
    refs.anuncio.hidden = !(cfg.modulos.anuncio && cfg.textos.anuncio && !vazio);
    if (!refs.anuncio.hidden) ligarTimer();

    if (cfg.modulos.recompensas && cfg.brinde && cfg.brinde.limiar) {
      refs.recompensas.hidden = vazio;
      var limiar = Math.round(cfg.brinde.limiar * 100);
      var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var pct = Math.min(100, total / limiar * 100);
      refs.preench.style.width = pct.toFixed(2) + '%';
      var chegou = total >= limiar;
      refs.marcoIcone.classList.toggle('is-complete', chegou);
      refs.recompensaMsg.innerHTML = chegou ? tpl(cfg.textos.recompensa_depois, { brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' })
        : tpl(cfg.textos.recompensa_antes, { restante: '<strong>' + dinheiro(limiar - total) + '</strong>', brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' });
    } else refs.recompensas.hidden = true;

    // redesenha uma vez, quando o compare-at chega: sem isto o riscado e a economia de cada
    // linha so apareciam na SEGUNDA abertura da gaveta. Espera TODOS os produtos do carrinho:
    // com um redesenho por produto, o primeiro a chegar gastava a unica volta e as outras
    // linhas ficavam com o riscado errado (visto com leggings + brinde na mesma gaveta).
    var faltando = c.items.filter(function (i) { return i.handle && !cacheProduto[i.handle]; });
    if (faltando.length) {
      Promise.all(faltando.map(function (i) { return api.produto(i.handle); })).then(function () {
        if (carrinho !== c) return;          // o guard de carrinho igual impede laco
        atualizarEconomia(c);
        if (!c._ewcRedesenhado) { c._ewcRedesenhado = true; render(c); }
      });
    }
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
    refs.subtotal.textContent = dinheiro(c.total_price);
    refs.checkout.textContent = tpl(cfg.textos.checkout, { total_price: dinheiro(c.total_price),
                                                           cart_quantity: c.item_count });

    var soAcessorio = c.item_count > 0 && principais(c).length === 0 && cfg.modulos.gate_so_upsell;
    refs.checkout.classList.toggle('is-disabled', vazio || soAcessorio);
    refs.aviso.hidden = !soAcessorio;

    renderUpsells(c);
    atualizarContadores(c.item_count);
    brindeAutomatico(c);
    document.dispatchEvent(new CustomEvent('ewc:cart:updated', { detail: { cart: c } }));
  }
  function atualizarEconomia(c) {
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
  }
  function compareAtDaLinha(item) {
    // compare-at da variante DESTA linha, lido do /products/x.js que ja esta em cache.
    // O riscado por item e a economia por item existem em toda gaveta de app (a referencia
    // mostra "$235.00" riscado e "(Save $165.05)" em verde na linha) e faltavam aqui.
    var p = produtoPronto[item.handle];
    if (!p) return 0;
    var v = (p.variants || []).filter(function (x) { return x.id === item.variant_id; })[0];
    return v && v.compare_at_price > item.original_price ? v.compare_at_price * item.quantity : 0;
  }
  function compareAt(c) {
    // economia contra o preço de tabela, quando o produto tem compare-at (lido do /products/x.js já em cache)
    var soma = 0;
    c.items.forEach(function (i) {
      var p = produtoPronto[i.handle];
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.id === i.variant_id; })[0];
      if (v && v.compare_at_price > i.original_price) soma += (v.compare_at_price - i.original_price) * i.quantity;
    });
    return soma;
  }
  function linha(item) {
    var brinde = ehBrinde(item) || item.final_line_price === 0;
    var n = el('div', 'ewc-cart__item');
    var ICONE_ETIQUETA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V4.8A2 2 0 0 1 4.8 2.8H12a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z"></path><circle cx="7.3" cy="7.3" r="1.1" fill="currentColor" stroke="none"></circle></svg>';
  var ICONE_MENOS = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1.5 6h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>';
  var ICONE_MAIS = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>';
  var img = el('img', 'ewc-cart__img'); if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
    var info = el('div', 'ewc-cart__info');

    // 1. nome e, na ponta, a lixeira (como na dela: nao um link "Remove" embaixo)
    var topo = el('div', 'ewc-cart__item-topo');
    var nome = el('h3', 'ewc-cart__nome'); var a = el('a', null, item.product_title); a.href = item.url; nome.appendChild(a);
    topo.appendChild(nome);
    var rem = el('button', 'ewc-cart__remover'); rem.type = 'button';
    rem.setAttribute('aria-label', cfg.textos.remover); rem.title = cfg.textos.remover;
    rem.setAttribute('data-ewc-acao', 'remover'); rem.setAttribute('data-ewc-chave', item.key);
    rem.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
    topo.appendChild(rem);
    info.appendChild(topo);

    // 2. as opcoes numa linha so: "Color: Black, Size: XS"
    var partes = [];
    if (item.options_with_values && item.options_with_values.length) {
      item.options_with_values.forEach(function (o) {
        if (o && o.value && o.value !== 'Default Title') partes.push(o.name + ': ' + o.value);
      });
    } else if (item.variant_title && item.variant_title !== 'Default Title') partes.push(item.variant_title);
    Object.keys(item.properties || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && item.properties[k]) partes.push(k + ': ' + item.properties[k]);
    });
    if (partes.length) info.appendChild(el('p', 'ewc-cart__variante', partes.join(', ')));

    // 3. preco antes do desconto, preco cobrado e economia na MESMA linha.
    // Medido na referencia em 2026-10-15, nos dois estados: com 2 leggings (pacote) ela
    // risca 99,80, que e 2x49,90 — o preco de LINHA antes do desconto, nao o preco-antes
    // do catalogo (2x69,90 = 139,80) — e diz '(Save $49.90)', so o desconto do pacote;
    // com 1 legging ela mostra apenas 49,90, sem riscado e sem economia, mesmo o produto
    // tendo preco-antes no catalogo. Ou seja: a semantica do proprio Shopify. Somar o
    // compare-at aqui inflava a economia anunciada (dizia 'Save $89.90' onde ela diz 49,90).
    var antes = item.original_line_price > item.final_line_price ? item.original_line_price : 0;
    var precos = el('div', 'ewc-cart__precos-linha');
    if (antes > item.final_line_price) precos.appendChild(el('span', 'ewc-cart__riscado', dinheiro(antes)));
    precos.appendChild(el('span', 'ewc-cart__preco', brinde && item.final_line_price === 0 ? dinheiro(0) : dinheiro(item.final_line_price)));
    if (!brinde && antes > item.final_line_price && cfg.textos.economia_item) {
      precos.appendChild(el('span', 'ewc-cart__economia-item',
        tpl(cfg.textos.economia_item, { amount: dinheiro(antes - item.final_line_price) })));
    }
    info.appendChild(precos);

    // 4. quantidade e, ao lado, os seloes de desconto da linha
    var baixo = el('div', 'ewc-cart__linha-baixo');
    if (brinde) baixo.appendChild(el('span', 'ewc-cart__variante', cfg.textos.gratis));
    else {
      var q = el('div', 'ewc-cart__qtd');
      var menos = el('button', null, ''); menos.innerHTML = ICONE_MENOS; menos.type = 'button'; menos.setAttribute('data-ewc-acao', 'menos'); menos.setAttribute('data-ewc-chave', item.key); menos.setAttribute('data-ewc-qtd', item.quantity);
      var mais = el('button', null, ''); mais.innerHTML = ICONE_MAIS; mais.type = 'button'; mais.setAttribute('data-ewc-acao', 'mais'); mais.setAttribute('data-ewc-chave', item.key); mais.setAttribute('data-ewc-qtd', item.quantity);
      q.appendChild(menos); q.appendChild(el('span', null, String(item.quantity))); q.appendChild(mais);
      baixo.appendChild(q);
    }
    var chips = el('div', 'ewc-cart__chips');
    // a dela poe um icone de etiqueta antes do texto em todo chip de desconto
    var comEtiqueta = function (cls, texto) {
      var c = el('span', cls, '');
      c.innerHTML = ICONE_ETIQUETA;
      var t = document.createElement('span'); t.textContent = texto; c.appendChild(t);
      return c;
    };
    if (brinde) chips.appendChild(comEtiqueta('ewc-cart__chip ewc-cart__chip--gratis', cfg.textos.gratis));
    (item.line_level_discount_allocations || []).forEach(function (al) {
      var t = al.discount_application && al.discount_application.title;
      if (t) chips.appendChild(comEtiqueta('ewc-cart__chip', t));
    });
    if (chips.childNodes.length) baixo.appendChild(chips);
    info.appendChild(baixo);

    n.appendChild(img); n.appendChild(info);
    return n;
  }
  function renderUpsells(c) {
    if (!cfg.modulos.upsells || !cfg.upsells || !cfg.upsells.length || !c.items.length) { refs.upsells.hidden = true; return; }
    var noCarrinho = {}; c.items.forEach(function (i) { noCarrinho[i.handle] = true; });
    var candidatos = cfg.upsells.filter(function (u) {
      if (noCarrinho[u.handle]) return false;
      if (u.gatilho_handles && u.gatilho_handles.length) return u.gatilho_handles.some(function (h) { return noCarrinho[h]; });
      return true;
    });
    if (!candidatos.length) { refs.upsells.hidden = true; return; }
    if (cfg.maximo_upsells) candidatos = candidatos.slice(0, cfg.maximo_upsells);
    refs.upsells.hidden = false; refs.upsells.innerHTML = '';
    refs.upsells.appendChild(el('p', 'ewc-cart__upsells-titulo', cfg.textos.upsell_titulo));
    candidatos.forEach(function (u) {
      var tile = el('div', 'ewc-cart__upsell'); tile.setAttribute('data-ewc-upsell', u.handle);
      refs.upsells.appendChild(tile);
      api.produto(u.handle).then(function (p) {
        if (!p) { tile.remove(); return; }
        var img = el('img'); img.src = (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2'); img.alt = '';
        var info = el('div', 'ewc-cart__upsell-info'); info.appendChild(el('strong', null, p.title));
        var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var precoTxt = el('span'); precoTxt.innerHTML = (v0.compare_at_price > v0.price ? '<span class="ewc-cart__riscado">' + dinheiro(v0.compare_at_price) + '</span>' : '') + dinheiro(v0.price);
        info.appendChild(precoTxt);
        var sel = null;
        if (p.variants.length > 1) {
          sel = el('select');
          p.variants.forEach(function (v) { var o = el('option', null, v.title); o.value = v.id; o.disabled = !v.available; sel.appendChild(o); });
          sel.value = String(v0.id);
          sel.addEventListener('change', function () { var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (v) precoTxt.innerHTML = (v.compare_at_price > v.price ? '<span class="ewc-cart__riscado">' + dinheiro(v.compare_at_price) + '</span>' : '') + dinheiro(v.price); });
        }
        var btn = el('button', 'ewc-cart__upsell-add', cfg.textos.upsell_adicionar); btn.type = 'button';
        btn.setAttribute('data-ewc-acao', 'upsell'); btn.setAttribute('data-ewc-variante', String(v0.id));
        if (sel) sel.addEventListener('change', function () { btn.setAttribute('data-ewc-variante', sel.value); });
        var acao = el('div', 'ewc-cart__upsell-acao');
        if (sel) acao.appendChild(sel);
        acao.appendChild(btn);
        info.appendChild(acao);
        tile.appendChild(img); tile.appendChild(info);
      });
    });
  }

  /* ------------------------------------------------------------ ações */
  function atualizar() { return api.carrinho().then(render).catch(function () {}); }
  function mudar(chave, qtd) {
    if (ocupado) return; ocupado = true;
    api.change(chave, qtd).then(render).catch(function () {}).then(function () { ocupado = false; });
  }
  function adicionarUpsell(btn) {
    var vid = parseInt(btn.getAttribute('data-ewc-variante') || '0', 10); if (!vid || ocupado) return;
    ocupado = true; btn.disabled = true;
    api.add([{ id: vid, quantity: 1, properties: { _ewc_upsell: '1' } }]).then(atualizar).catch(function () {}).then(function () { ocupado = false; btn.disabled = false; });
  }
  var brindeOcupado = false;
  function brindeAutomatico(c) {
    var b = cfg.brinde; if (!b || !b.variante_id || !b.limiar || brindeOcupado) return;
    var limiar = Math.round(b.limiar * 100);
    var linhasBrinde = c.items.filter(ehBrinde);
    var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var elegivel = total >= limiar && principais(c).length > 0;
    var ss = window.sessionStorage;
    function guardar(k, v) { try { v == null ? ss.removeItem(k) : ss.setItem(k, v); } catch (e) {} }
    function ler(k) { try { return ss.getItem(k); } catch (e) { return null; } }
    if (elegivel && !linhasBrinde.length && !ler('ewcBrindeRemovido')) {
      brindeOcupado = true;
      api.add([{ id: parseInt(b.variante_id, 10), quantity: 1, properties: { _ewc_gift: '1' } }])
        .then(function () { guardar('ewcBrindeAdicionado', '1'); return atualizar(); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (!elegivel && linhasBrinde.length) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 0).then(function (nc) { guardar('ewcBrindeAdicionado', null); render(nc); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (elegivel && !linhasBrinde.length && ler('ewcBrindeAdicionado')) {
      guardar('ewcBrindeRemovido', '1'); guardar('ewcBrindeAdicionado', null);   // o cliente tirou de propósito
    } else if (linhasBrinde.length && linhasBrinde[0].quantity > 1) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 1).then(render).catch(function () {}).then(function () { brindeOcupado = false; });
    }
  }
  function ligarTimer() {
    if (!cfg.timer_segundos) { refs.timer.textContent = ''; return; }
    var chave = 'ewcTimerInicio', inicio;
    try { inicio = parseInt(sessionStorage.getItem(chave) || '0', 10); } catch (e) { inicio = 0; }
    if (!inicio) { inicio = Date.now(); try { sessionStorage.setItem(chave, String(inicio)); } catch (e) {} }
    function tique() {
      var resta = Math.max(0, cfg.timer_segundos - Math.floor((Date.now() - inicio) / 1000));
      var m = Math.floor(resta / 60), s = resta % 60;
      refs.timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (resta === 0) { clearInterval(relogio); relogio = null; }
    }
    tique(); if (!relogio) relogio = setInterval(tique, 1000);
  }
  function atualizarContadores(n) {
    var sel = SEL.contadores + (cfg.adaptador.contadores ? ',' + cfg.adaptador.contadores : '');
    document.querySelectorAll(sel).forEach(function (e) {
      if (raiz.contains(e)) return;
      if (/^\s*\d*\s*$/.test(e.textContent)) e.textContent = String(n);
      else e.textContent = e.textContent.replace(/\d+/, String(n));
    });
  }

  /* O tema estreita .page-wrapper quando acha que uma gaveta dele abriu. A nossa gaveta
     cobre a tela inteira e nao precisa desse espaco: a classe sai nos dois momentos. */
  function dialogosDoTema() {
    var fora = [];
    try {
      document.querySelectorAll('dialog[open]').forEach(function (d) {
        if (!raiz || !raiz.contains(d)) fora.push(d);
      });
    } catch (e) {}
    return fora;
  }

  /* So a gaveta de CARRINHO do tema e fechada. Menu, busca e chat sao painieis dele que a
     pessoa abre de proposito e que a nossa gaveta nao substitui. */
  function ehDoCarrinho(d) {
    try {
      if (d.closest('#cart-drawer,[id*="cart-drawer"],cart-drawer,.cart-drawer,[data-cart-drawer]')) return true;
      return !!d.querySelector('cart-items,[class*="cart-drawer"],form[action*="/cart"]');
    } catch (e) { return false; }
  }

  /* O tema registra o ouvinte do botao da sacola ANTES do nosso, entao a gaveta DELE abre
     mesmo com o clique barrado - como dialogo MODAL, que deixa o resto da pagina inerte.
     E ele guarda esse estado: no carregamento seguinte reabre sozinho, invisivel sob a
     nossa, mas com a classe que estreita a pagina. Por isso a limpeza e vigiada, nao
     pontual. 'fechar_tudo' so no inicio da pagina e quando a nossa gaveta abre: nesses
     momentos nenhum painel do tema deveria estar aberto por vontade de ninguem. */
  function soltarEncolhimento(fechar_tudo) {
    if (fechar_tudo) {
      dialogosDoTema().forEach(function (d) {
        if (ehDoCarrinho(d)) { try { d.close(); } catch (e) {} }
      });
    }
    // o que sobrou aberto na tela decide: sem painel do tema vivo, nada de trava nem de
    // pagina estreitada
    var vivo = dialogosDoTema().some(function (d) { return d.getBoundingClientRect().width > 0; });
    if (!vivo) document.documentElement.removeAttribute('scroll-lock');
    var w = document.querySelector('.page-wrapper');
    if (!w || !w.classList.contains('page-wrapper--drawer-open')) return;
    if (!vivo) w.classList.remove('page-wrapper--drawer-open');
  }

  function vigiarEncolhimento() {
    soltarEncolhimento(true);
    [150, 500, 1200, 2500].forEach(function (t) { setTimeout(function () { soltarEncolhimento(true); }, t); });
    var w = document.querySelector('.page-wrapper');
    if (!w || !window.MutationObserver) return;
    // guarda contra laco: so age quando a classe ESTA la, e a propria remocao a tira
    new MutationObserver(function () {
      if (w.classList.contains('page-wrapper--drawer-open')) soltarEncolhimento(false);
    }).observe(w, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------ abrir / fechar */
  function abrir() {
    if (aberto) return;
    aberto = true; raiz.hidden = false; raiz.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { raiz.classList.add('is-open'); });
    document.documentElement.classList.add('ewc-cart-aberto');
    // o Horizon rola dentro de .page-wrapper acima de 990px; quem trava e o atributo do tema
    document.documentElement.setAttribute('data-ewc-cart-lock', '1');
    soltarEncolhimento(true);
    // o tema pode abrir a gaveta dele um instante depois do clique: passadas atrasadas
    [180, 600, 1500].forEach(function (t) { setTimeout(function () { soltarEncolhimento(true); }, t); });
    atualizar();
    document.dispatchEvent(new CustomEvent('ewc:cart:open'));
  }
  function fechar() {
    if (!aberto) return;
    aberto = false; raiz.classList.remove('is-open'); document.documentElement.classList.remove('ewc-cart-aberto');
    document.documentElement.removeAttribute('data-ewc-cart-lock');
    soltarEncolhimento(true);
    setTimeout(function () { if (!aberto) { raiz.hidden = true; raiz.setAttribute('aria-hidden', 'true'); } }, 300);
  }

  /* ------------------------------------------------------------ adaptador */
  function esconderNativa() {
    var css = document.createElement('style');
    css.setAttribute('data-ewc-cart', 'esconde-nativa');
    var sel = SEL.gaveta_nativa + (cfg.adaptador.gaveta_nativa ? ',' + cfg.adaptador.gaveta_nativa : '');
    css.textContent = sel + '{display:none !important;visibility:hidden !important}';
    document.head.appendChild(css);
  }
  function instalarGatilhos() {
    var sel = SEL.gatilhos + (cfg.adaptador.gatilhos ? ',' + cfg.adaptador.gatilhos : '');
    function doNosso(ev) {
      var alvo = ev.target.closest && ev.target.closest(sel);
      if (!alvo || raiz.contains(alvo) || alvo.hasAttribute('data-ewc-skip')) return null;
      var href = alvo.getAttribute('href') || '';
      if (href && !/\/cart(\/|\?|$)/.test(href)) return null;
      return alvo;
    }
    // Alguns temas (Horizon) abrem a gaveta DELES no pointerdown/mousedown, antes do clique.
    // Se ela abrir, vira um dialogo modal: o resto da pagina fica inerte e nem o botao de
    // fechar da nossa gaveta recebe clique. Por isso o gatilho e barrado ja nesses eventos.
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (nome) {
      document.addEventListener(nome, function (ev) {
        if (!doNosso(ev)) return;
        ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      }, true);
    });
    document.addEventListener('click', function (ev) {
      if (!doNosso(ev)) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      abrir();
    }, true);
  }
  function itensDoFormulario(form) {
    var fd = new FormData(form), id = parseInt(fd.get('id') || '0', 10), qtd = parseInt(fd.get('quantity') || '1', 10) || 1, props = {};
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
    if (!id) return null;
    var item = { id: id, quantity: qtd }; if (Object.keys(props).length) item.properties = props;
    var plano = fd.get('selling_plan'); if (plano) item.selling_plan = plano;
    return [item];
  }
  function instalarFormularios() {
    var ignorar = cfg.adaptador.ignorar_formularios;
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (raiz.contains(form) || form.hasAttribute('data-ewc-skip') || form.hasAttribute('data-ewc-bundle-form')) return;
      if (ignorar && form.closest(ignorar)) return;
      var itens = itensDoFormulario(form); if (!itens) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"],button[name="add"]'); if (btn) btn.disabled = true;
      api.add(itens).then(function () { if (cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else atualizar(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);
  }
  function vigiarRede() {
    // o tema pode adicionar por JavaScript próprio (sem submit): ver a rede é o único gancho que vale em todo tema
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function' && !fetchOriginal._ewc) {
      var f = function (entrada, opts) {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        var p = fetchOriginal.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !(opts && opts.headers && opts.headers['X-Ewc'])) {
          p.then(function (r) {
            if (!r.ok) return;
            if (/\/cart\/add/.test(url) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar();
          }).catch(function () {});
        }
        return p;
      };
      f._ewc = true; window.fetch = f;
    }
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) { if (/\/cart\/add/.test(String(url)) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar(); }
        });
      }
      return abrirXhr.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ início */
  function iniciar() {
    raiz = document.getElementById('ewc-cart-root'); if (!raiz) return;
    cfg = lerConfig();
    montar(); esconderNativa(); instalarGatilhos(); instalarFormularios(); vigiarRede();
    vigiarEncolhimento();
    document.addEventListener('ewc:cart:added', function () { abrir(); });
    document.addEventListener('cart:refresh', function () { if (aberto) atualizar(); });
    window.addEventListener('pageshow', function () { ocupado = false; brindeOcupado = false; vigiarEncolhimento(); if (aberto) atualizar(); else api.carrinho().then(function (c) { atualizarContadores(c.item_count); }).catch(function () {}); });
    api.carrinho().then(function (c) { carrinho = c; atualizarContadores(c.item_count); brindeAutomatico(c); }).catch(function () {});
    window.EwcCart = { abrir: abrir, fechar: fechar, atualizar: atualizar, carrinho: function () { return carrinho; }, config: function () { return cfg; } };
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  } catch (e) { /* falha aberto */ }
})();
